export default __webpack_public_path__ + "assets/images/e70acbd1c8242f8b462cbad81facc2a3.jpg";